import { useQueryClient } from '@tanstack/react-query';
import { formNames } from '@wkda/carlead-creation-form';
import { useModulesStore } from '@wkda/funnel-components';
import pick from 'lodash-es/pick';
import { useCarleadConfiguration } from '../../../hooks/useCarleadCreationConfiguration';
export function useSplitFieldsMachineServices() {
  const queryClient = useQueryClient();
  const {
    carTypesSplitModule
  } = useModulesStore();
  const {
    fullLocale,
    country
  } = useCarleadConfiguration();
  const languageParams = {
    locale: fullLocale,
    country
  };

  function getFetchService(pickParams, fieldName, fetchFn) {
    return function fetch(_ref) {
      let {
        values
      } = _ref;
      const params = pick(values, pickParams);
      return queryClient.fetchQuery({
        queryKey: [fieldName, params],
        queryFn: () => {
          return fetchFn({ ...params,
            ...languageParams
          });
        }
      });
    };
  }

  return {
    fetchManufacturers() {
      const request = queryClient.fetchQuery({
        queryKey: [formNames.manufacturer],
        queryFn: () => {
          return carTypesSplitModule.getManufacturers({ ...languageParams
          });
        }
      });
      return request;
    },

    fetchMainTypes: getFetchService(['manufacturer'], formNames.mainType, carTypesSplitModule.getMainTypes),
    fetchBuiltDates: getFetchService(['manufacturer', 'mainType'], formNames.builtDate, carTypesSplitModule.getBuiltDates),
    fetchBodyTypes: getFetchService(['manufacturer', 'mainType', 'builtDate'], formNames.bodyType, carTypesSplitModule.getBodyTypes),
    fetchFuelTypes: getFetchService(['manufacturer', 'mainType', 'builtDate', 'bodyType'], formNames.fuelType, carTypesSplitModule.getFuelTypes),
    fetchMainTypeDetails: getFetchService(['manufacturer', 'mainType', 'builtDate', 'bodyType', 'fuelType'], formNames.mainTypeDetail, carTypesSplitModule.getMainTypesDetails),
    fetchHorsePower: getFetchService(['manufacturer', 'mainType', 'builtDate', 'bodyType', 'fuelType', 'mainTypeDetail'], formNames.horsePower, carTypesSplitModule.getHorsePower),
    fetchGearTypes: getFetchService(['manufacturer', 'mainType', 'builtDate', 'bodyType', 'fuelType', 'mainTypeDetail', 'horsePower'], formNames.gearType, carTypesSplitModule.getGearTypes),
    fetchDoorCount: getFetchService(['manufacturer', 'mainType', 'builtDate', 'bodyType', 'fuelType', 'mainTypeDetail', 'horsePower', 'gearType'], formNames.doorCount, carTypesSplitModule.getDoorCount),
    fetchMainTypeSub: getFetchService(['manufacturer', 'mainType', 'builtDate', 'bodyType', 'fuelType', 'mainTypeDetail', 'horsePower', 'gearType', 'doorCount'], formNames.mainTypeSub, carTypesSplitModule.getMainTypesSub)
  };
}